import { Trans } from '@lingui/react'
import type { FC } from 'react'

import { TENANT_BE } from 'shared/consts'
import MountPoints from 'shared/utils/mountPoints'
import QuerySuggestionsList from 'views/components/organisms/SearchBox/AfterQuerySuggestLayer/QuerySuggestionsList'
import RedirectsList from 'views/components/organisms/SearchBox/AfterQuerySuggestLayer/RedirectsList'

export type RedirectData = Array<{
  redirectTarget: string
  type: string
  suggestText?: string
}>

const AfterQuerySuggestLayer: FC<
  {
    mountPoints: MountPoints
    querySuggestions: string[]
    redirectData: RedirectData
    shopUrl: string
    tenant: string
  } | null
> = ({ mountPoints, shopUrl, querySuggestions, redirectData, tenant }) => {
  const redirectCategories: RedirectData = []
  const redirectLandingPages: RedirectData = []

  redirectData.map(redirect => {
    if (redirect.type === 'redirect') {
      redirectLandingPages.push(redirect)
    } else if (redirect.type === 'category') {
      redirectCategories.push(redirect)
    }
  })

  return (
    (tenant === TENANT_BE && redirectLandingPages.length > 0 && (
      <>
        <div className="u-font-weight--bold u-padding--bottom">
          <Trans id="general.label.search" />
        </div>
        <ul className="a-list-reset u-margin--bottom">
          <RedirectsList
            redirectData={redirectLandingPages}
            shopUrl={shopUrl}
          />
        </ul>
      </>
    )) ||
    ((redirectLandingPages.length > 0 || querySuggestions.length > 0) && (
      <div>
        <div className="u-font-weight--bold u-padding--bottom">
          <Trans id="general.label.search" />
        </div>
        <ul className="a-list-reset u-margin--bottom">
          {querySuggestions.length > 0 && (
            <QuerySuggestionsList
              querySuggestions={querySuggestions}
              mountPoints={mountPoints}
            />
          )}
          {redirectLandingPages.length > 0 && (
            <RedirectsList
              redirectData={redirectLandingPages}
              shopUrl={shopUrl}
            />
          )}
        </ul>
      </div>
    )) ||
    null
  )
}

export default AfterQuerySuggestLayer
